import { useState, useEffect } from 'react';
import { getMySubscriptions } from '../api/subscription-api';
import { ProjectSubscription } from '../types/subscription';
import { handleApiError } from '@/shared/api/requests';

export const useMySubscriptions = () => {
  const [subscriptions, setSubscriptions] = useState<ProjectSubscription[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchSubscriptions = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await getMySubscriptions();
      setSubscriptions(data);
    } catch (err) {
      const errorMessage = handleApiError(err);
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSubscriptions();
  }, []);

  return {
    subscriptions,
    loading,
    error,
    refetch: fetchSubscriptions,
  };
};

